import axios, { AxiosResponse } from "axios";
import { RequestConnection } from "../../models/RequestConnection";
import { PageSetting, ProductRaw, Query, SortMode } from "../../interfaces";
import ConnectionClient from "../../shared/api-client";

export const saveRequest = async (request: RequestConnection) => {
  const client = new ConnectionClient();
  const result = await client.api.post(
    `${process.env.REACT_APP_API_HOST}/items/connection_request`,
    {
      content: request.content,
      organization_name: request.organization_name,
      owner_email: request.to?.email,
      request_type: request.request_type,
      actor_type: request.actor_type?.id,
    }
  );
  return result.data;
};

export const Find = async (
  collection: string,
  query: Query,
  page: number = PageSetting.page,
  limit: number = PageSetting.limit
) => {
  const { REACT_APP_API_HOST } = process.env;

  if (!REACT_APP_API_HOST) {
    throw new Error("API host is not configured.");
  }

  const metadata = `?meta=${
    query.meta ? query.meta : `total_count&page=${page}&limit=${limit}`
  }`;
  const fields = "&fields=*.*.*";
  const filter = query.filter
    ? `&${Object.entries(query.filter)
        .map(([key, value]) => `${key}=${value}`)
        .join("&")}`
    : "";
  const sort = query.sort
    ? `&sort=${query.sort
        .map(({ field, mode }) => (mode === SortMode.DES ? `-${field}` : field))
        .join(",")}`
    : "";
  const uri = `${REACT_APP_API_HOST}/items/${collection}${metadata}${fields}${filter}${sort}&search=${
    query.search || ""
  }`;

  try {
    const response: AxiosResponse = await axios.get(uri);
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw new Error("Failed to fetch data.");
  }
};

export const Create = async (product: ProductRaw) => {
  const client = new ConnectionClient();
  const result = await client.api.post(
    `${process.env.REACT_APP_API_HOST}/items/products`,
    product
  );
  return result.data;
};

export const Update = async (id: string, product: ProductRaw) => {
  const client = new ConnectionClient();
  const result = await client.api.patch(
    `${process.env.REACT_APP_API_HOST}/items/products/${id}`,
    product
  );
  return result.data;
};

export const Remove = async (id: string) => {
  const client = new ConnectionClient();
  const result = await client.api.delete(
    `${process.env.REACT_APP_API_HOST}/items/products/${id}`
  );
  return result.data;
};

export const changeRequestStatus = async (request: RequestConnection) => {
  const client = new ConnectionClient();

  const result = await client.api.patch(
    `${process.env.REACT_APP_API_HOST}/items/connection_request/${request.id}`,
    {
      request_status: request.status,
    }
  );

  return result.data;
};

export const reject = async (request: RequestConnection) => {
  const client = new ConnectionClient();
  const result = await client.api.patch(
    `${process.env.REACT_APP_API_HOST}/items/connection_request`,
    {
      content: request.content,
    }
  );
  return result.data;
};

export const setOwn = async (id: string, userId: string) => {
  const client = new ConnectionClient();
  const result = await client.api.patch(
    `${process.env.REACT_APP_API_HOST}/items/connection_request/${id}`,
    {
      owner: userId,
    }
  );

  return result.data;
};

export const sendNotification = async (data: RequestConnection) => {
  const result = await axios.post(
    `${process.env.REACT_APP_API_HOST}/connection-request/invite`,
    data
  );
  return result.data;
};

export const sendNotificationConfirm = async (data: RequestConnection) => {
  const result = await axios.post(
    `${process.env.REACT_APP_API_HOST}/connection-request/invite-accepted`,
    data
  );
  return result.data;
};

export const FindById = async (id: string, populate: string) => {
  const client = new ConnectionClient();
  const result = await client.api.get(
    `${process.env.REACT_APP_API_HOST}/items/products/${id}${
      populate ? `?${populate}` : ""
    }`
  );
  return result.data;
};
